<ng-container *ngIf="retailPlace$ | async as retailPlace">
  <div class="ui-kit-block-title" data-qa="kkm-retail-place-title">
    {{ 'kkm.settings.retail.place' | translate }}
  </div>
  <ng-container *ngFor="let item of kkmRetailPlaceInfo">
    <div *ngIf="retailPlace[item.property] as value" class="ui-kit-layout-columns-2">
      <span [attr.data-qa]="'kkm-retail-place-' + item.property + '-name'">{{
        item.title | translate
      }}</span>
      <span [attr.data-qa]="'kkm-retail-place-' + item.property"> {{ value }}</span>
    </div>
  </ng-container>
</ng-container>
